






















































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import {
  ContractorNewEdit as IContractorNewEdit,
  ContractorNewEditTypeEnum
} from "@/api/models/contractor-new-edit";
import { getCurrentCompanyId, getCurrentEmployee } from "@/plugins/roles";
import { ContractorNew as IContractorNew } from "@/api/models/contractor-new";
import {
  JuridicalContractorEdit,
  JuridicalContractorEditTypeEnum,
  PhysicalContractorEdit,
  PhysicalContractorEditTypeEnum
} from "@/api/models";
import { ContactPerson as IContactPerson } from "@/api/models/contact-person";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import api from "@/getinfo-api";
import CustomInputPhone from "@/components/form/CustomInputPhone.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { UsersListClass } from "@/classes/list/UsersListClass";
import EditorWithFile from "@/components/EditorWithFile.vue";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";
import moment from "moment";
import SearchInput from "@/components/form/SearchInput.vue";
import { daDataService } from "@/plugins/dadata/service";
import StudentTable from "@/components/students/StudentTable.vue";
import { Student as IStudent } from "@/api-v2/course/models";
import SearchUser from "@/components/user/SearchUser.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { studentLimitModule } from "@/plugins/modules-detect";
import students, { StudentsListParams } from "@/getinfo-api/students";
import { uniqBy } from "lodash";

@Component({
  components: {
    CustomButton,
    CustomDatepicker,
    SearchUser,
    StudentTable,
    SearchInput,
    EditorWithFile,
    CustomInputPhone,
    CPageButtons,
    CSingleSelect,
    CField,
    CBlock,
    CPage
  }
})
export default class ContractorFormV2 extends Vue {
  @Prop() contractor!: IContractorNew;

  params: IContractorNewEdit = {
    type: ContractorNewEditTypeEnum.Physical,
    companyId: this.currentCompany(),
    phone: "",
    email: "",
    studentIds: []
  };

  physParams: PhysicalContractorEdit = {
    firstName: "",
    lastName: "",
    middleName: "",
    type: PhysicalContractorEditTypeEnum.Physical,
    companyId: this.currentCompany(),
    phone: "",
    email: "",
    responsibleId: this.currentEmployee ? this.currentEmployee.id : "",
    studentIds: [],
    userId: this.contractor?.user?.id ?? ""
  };

  jurParams: JuridicalContractorEdit = {
    title: "",
    shortTitle: "",
    inn: "",
    legalAddress: "",
    factAddress: "",
    kpp: "",
    ogrn: "",
    paymentAccount: "",
    correspondentAccount: "",
    directorNameInitials: "",
    directorPositionGenitive: "",
    bank: "",
    bik: "",
    directorName: "",
    directorNameGenitive: "",
    directorPosition: "",
    basis: "",
    type: JuridicalContractorEditTypeEnum.Juridical,
    companyId: this.currentCompany(),
    phone: "",
    email: "",
    responsibleId: this.currentEmployee ? this.currentEmployee.id : null,
    studentIds: []
  };

  contactPerson: IContactPerson = {};
  checkedStudents: IStudent[] = [];
  showSearchUserPlugin: boolean = true;
  selectedStudents: IStudent[] = [];
  types: Array<Object> = [
    {
      value: ContractorNewEditTypeEnum.Physical,
      label: this.$tc(this.$translate.PhysicalPerson)
    },
    {
      value: ContractorNewEditTypeEnum.Juridical,
      label: `${this.$tc(this.$translate.LegalPerson)}`
    }
  ];
  genderOptions: Array<Object> = [
    {
      value: 0,
      label: this.$tc(this.$translate.Male)
    },
    {
      value: 1,
      label: this.$tc(this.$translate.Female)
    }
  ];
  comment!: string;
  isSaving: boolean = false;
  usersList: UsersListClass = new UsersListClass(
    {},
    this.contractor?.user?.id ?? undefined
  );
  employeeList: EmployeesListClass = new EmployeesListClass({
    id: this.currentCompany(),
    roles: ["learning_request_manager"]
  });
  currentStudents: IStudent[] = [];
  userRegisteredAtMin!: Date | undefined;
  userRegisteredAtMax!: Date | undefined;
  searchListenerByEmail!: string;

  data() {
    return {
      comment: undefined,
      detailUsersInfo: [],
      registeredUserEmail: undefined,
      userRegisteredAtMin: undefined,
      userRegisteredAtMax: undefined,
      searchListenerByEmail: undefined,
      selectedStudents: undefined
    };
  }

  get addedUserIds() {
    return this.checkedStudents.map(el => el.id);
  }

  get isStudentLimitModule() {
    return studentLimitModule() && this.$store.state.studentLimit !== 0;
  }

  get isBlockAddStudent() {
    return (
      this.isStudentLimitModule &&
      this.$store.state.studentLimit - this.$store.state.studentAmount <=
        this.addedUserIds.length
    );
  }

  updateSelectedStudents(students: IStudent[] = []) {
    this.selectedStudents = students;
  }

  async getStudents(offset: number = 0) {
    if (this.contractor.studentIds?.length) {
      const studentsCount = this.contractor.studentIds?.length;
      const limit = 300;

      try {
        let params: StudentsListParams = {
          belongToContractorId: this.contractor.id,
          offset: offset,
          limit: limit
        };
        const { data } = await students(params);
        this.checkedStudents = [...this.checkedStudents, ...data.items];

        if (studentsCount > this.checkedStudents?.length) {
          await this.getStudents(offset + limit);
        }
      } catch (e) {
        throw new Error(e);
      }
    }
  }

  get filteredStudents() {
    let filtered = this.checkedStudents;

    if (
      this.searchListenerByEmail !== undefined &&
      this.searchListenerByEmail !== null
    ) {
      filtered = filtered.filter(item => {
        const fullName = `${item.firstName} ${item.lastName} ${item.middleName}`;
        const email = item.email?.toLowerCase();
        const searchTerm = this.searchListenerByEmail.toLowerCase();

        if (email?.includes(searchTerm)) {
          return true;
        }

        return fullName.toLowerCase().includes(searchTerm);
      });
    }

    if (
      this.userRegisteredAtMin !== undefined &&
      this.userRegisteredAtMin !== null
    ) {
      filtered = filtered.filter(
        item => new Date(item.createdAt) >= this.userRegisteredAtMin!
      );
    }
    if (
      this.userRegisteredAtMax !== undefined &&
      this.userRegisteredAtMax !== null
    ) {
      filtered = filtered.filter(
        item => new Date(item.createdAt) <= this.userRegisteredAtMax!
      );
    }

    return filtered;
  }

  clearFilter() {
    this.searchListenerByEmail = "";
    this.userRegisteredAtMin = undefined;
    this.userRegisteredAtMax = undefined;
  }

  deleteUsers(item: any) {
    this.checkedStudents = this.checkedStudents.filter(element => {
      return element !== item;
    });
  }

  get currentCompany() {
    return getCurrentCompanyId;
  }

  get currentEmployee() {
    return getCurrentEmployee();
  }

  get searchContractors() {
    return daDataService.searchOrganizationByInn;
  }

  get searchBankInfo() {
    return daDataService.searchBanksByBik;
  }

  setContractorInfo(value: any) {
    this.jurParams.ogrn = value?.data?.ogrn ?? "";
    this.jurParams.title = value?.data?.name?.full_with_opf ?? "";
    this.jurParams.shortTitle = value?.data?.name?.short ?? "";
    this.jurParams.kpp = value?.data?.kpp ?? "";
    this.jurParams.okved = value?.data?.okved ?? "";
    this.jurParams.okato = value?.data?.okato ?? "";
    this.jurParams.okpo = value?.data?.okpo ?? "";
    this.jurParams.directorName = value?.data?.management?.name ?? "";
    this.jurParams.directorPosition = value?.data?.management?.post ?? "";
    this.jurParams.directorNameGenitive = value?.data?.management?.name ?? "";
    this.jurParams.legalAddress =
      value?.data?.address?.unrestricted_value ?? "";
  }

  setBankInfo(value: any) {
    this.jurParams.correspondentAccount = value?.data?.correspondent_account;
    this.jurParams.bank = value?.data?.name?.short;
  }

  async deleteContractor() {
    try {
      this.isSaving = true;
      await api.ContractorApi.deleteContractorNew(
        this.$route.params.contractorId
      );
      await this.$router.push({ name: "contractorList" });
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isSaving = false;
    }
  }

  createContractor(params: any) {
    this.isSaving = true;
    params.birthday = params.birthday ? params.birthday : undefined;
    params.educationDate = params.educationDate
      ? params.educationDate
      : undefined;
    //@ts-ignore
    api.ContractorApi.createContractorNew(params)
      .then((res: { data: any }) => {
        this.$router.push({
          name: "contractorItem",
          params: { contractorId: res.data.id }
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  editContractor(params: any) {
    this.isSaving = true;
    params.birthday = params.birthday ? params.birthday : undefined;
    params.educationDate = params.educationDate
      ? params.educationDate
      : undefined;
    //@ts-ignore
    api.ContractorApi.editContractorNew(this.$route.params.contractorId, params)
      .then((res: { data: any }) => {
        this.$router.push({
          name: "contractorItem",
          params: { contractorId: res.data.id }
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  async submit() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    let params =
      this.params?.type === ContractorNewEditTypeEnum.Physical
        ? this.physParams
        : this.jurParams;
    params.studentIds = this.checkedStudents.map(el => el.id);
    params.comment = this.comment;
    params.contactPerson = this.contactPerson;
    if (!this.contactPerson) {
      params.contactPerson = undefined;
    }
    this.contractor
      ? this.editContractor(params)
      : this.createContractor(params);
  }

  cancel() {
    this.$router.push({
      name: "contractorList"
    });
  }

  addStudents() {
    this.currentStudents = this.currentStudents.filter(student =>
      this.checkedStudents.some(
        checkedStudent => checkedStudent.id === student.id
      )
    );

    this.currentStudents = uniqBy(
      [...this.checkedStudents, ...this.currentStudents],
      "id"
    );
  }

  created() {
    if (this.contractor) {
      this.getStudents();
    }

    if (this.contractor.type) {
      this.contractor.comment ? (this.comment = this.contractor.comment) : null;
      //@ts-ignore
      this.params.type = this.contractor.type;
    }
    if (this.contractor.type === ContractorNewEditTypeEnum.Physical) {
      //@ts-ignore
      this.physParams = this.contractor;
      //@ts-ignore
      this.physParams.birthday = this.physParams.birthday
        ? moment(this.physParams.birthday).format("YYYY-MM-DD")
        : undefined;
      //@ts-ignore
      this.physParams.educationDate = this.physParams.educationDate
        ? moment(this.physParams.educationDate).format("YYYY-MM-DD")
        : undefined;
      this.physParams.companyId = this.contractor.company.id;
      this.contractor.user
        ? (this.physParams.userId = this.contractor.user.id)
        : null;
      this.contractor.responsible
        ? (this.physParams.responsibleId = this.contractor.responsible.id)
        : null;

      //@ts-ignore
      this.physParams.responsible = null;
      //@ts-ignore
      this.physParams.company = null;
      //@ts-ignore
      this.physParams.user = null;
    } else {
      //@ts-ignore
      this.jurParams = this.contractor;
      //@ts-ignore
      this.jurParams.companyId = this.contractor.company.id;
      //@ts-ignore
      this.contractor.responsible
        ? //@ts-ignore
          (this.jurParams.responsibleId = this.jurParams.responsible.id)
        : null;

      //@ts-ignore
      this.jurParams.responsible = null;
      //@ts-ignore
      this.contractor.user
        ? //@ts-ignore
          (this.jurParams.userId = this.contractor.user.id)
        : null;
      //@ts-ignore
      this.jurParams.company = null;
      //@ts-ignore
      this.jurParams.user = null;
    }
    if (this.contractor && this.contractor.contactPerson) {
      this.contactPerson = this.contractor.contactPerson;
    }
    if (Array.isArray(this.contractor.contactPerson)) {
      this.contactPerson = {};
    }
  }
}
